import { TextureLoader } from "three";
import images from "./images";

const dirtTexture = new TextureLoader().load(images.dirt);
const groundTexture = new TextureLoader().load(images.grass);
const tileTexture = new TextureLoader().load(images.tile);
export { dirtTexture, groundTexture, tileTexture };
